
import TextShrink from '~/ZenOne-StoryBook/components/TextShrink'

export default {
  name: 'ProductCardSku',
  components: { TextShrink },
  props: {
    sku: {
      type: String,
      default: '',
      required: true,
    },
    viewportWidth: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      maxLength: 10,
    }
  },
}
